var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-name":"Tiktok 16px","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.05 0h-2.7v10.9a2.33 2.33 0 1 1-4.66 0 2.37 2.37 0 0 1 2.27-2.37V5.8a5.1 5.1 0 1 0 5.13 5.1V5.31a6.24 6.24 0 0 0 3.58 1.2V3.79A3.76 3.76 0 0 1 11.05 0Z","fill":"#fefefe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }